import { SELECTION_KEY } from '@techchange/pm-specs';

/**
 * Finds the new start and end positions of a previously marked selection range.
 *
 * @param {Object} state     The current editor state.
 * @param {Object} tr        The current transaction instance.
 *
 * @returns {Array} The new from and to positions of the original selection.
 */
const getMarkedSelection = (state, tr) => {

	const { schema } = state;

	const selectionMarkType = schema.marks[SELECTION_KEY];

	let newFrom, newTo;

	// Find new selection positions based on marked nodes
	tr.doc.descendants((node, pos) => {

		const containsSelectionMark = node.marks &&
			node.marks.find((mark) => mark.type === selectionMarkType);

		if (containsSelectionMark) {

			// Let first occurrence of selection mark be the start of the new selection
			if (newFrom === undefined) {
				newFrom = pos;
			}

			// Let last occurrence of selection mark be the end of the new selection
			newTo = pos + node.nodeSize;

		}

		// Recurse to children
		return true;

	});

	return [newFrom, newTo];

};

export default getMarkedSelection;
